import { Card, CardContent } from "@mui/material";
import moment from "moment";
import React from "react";
import { StyledDetailsTable } from "../../../styled/accident";

const DetailsTableAccidents = ({ rowData }) => {
  return (
    <StyledDetailsTable.Container>
      <Card>
        <CardContent>
          <StyledDetailsTable.Details>
            <StyledDetailsTable.TextTitle>
              Administrador
            </StyledDetailsTable.TextTitle>
            <StyledDetailsTable.TextValue>
              {rowData.administrador || "---"}
            </StyledDetailsTable.TextValue>
          </StyledDetailsTable.Details>

          <StyledDetailsTable.Details>
            <StyledDetailsTable.TextTitle>
              Empleador
            </StyledDetailsTable.TextTitle>
            <StyledDetailsTable.TextValue>
              {rowData.empleador} ({rowData.cuitEmpleador || "---"})
            </StyledDetailsTable.TextValue>
          </StyledDetailsTable.Details>

          <StyledDetailsTable.Details>
            <StyledDetailsTable.TextTitle>Alta</StyledDetailsTable.TextTitle>
            <StyledDetailsTable.TextValue>
              {rowData.fechaAlta
                ? moment(rowData.fechaAlta).format("DD/MM/YYYY")
                : "---"}
            </StyledDetailsTable.TextValue>
          </StyledDetailsTable.Details>

          <StyledDetailsTable.Details>
            <StyledDetailsTable.TextTitle>
              Primera Curación
            </StyledDetailsTable.TextTitle>
            <StyledDetailsTable.TextValue>
              {rowData.fechaPrimeraCuracion
                ? moment(rowData.fechaPrimeraCuracion).format("DD/MM/YYYY")
                : "---"}
            </StyledDetailsTable.TextValue>
          </StyledDetailsTable.Details>

          <StyledDetailsTable.Details>
            <StyledDetailsTable.TextTitle>Estado</StyledDetailsTable.TextTitle>
            <StyledDetailsTable.TextValue>
              {rowData.estado || "---"}
            </StyledDetailsTable.TextValue>
          </StyledDetailsTable.Details>
        </CardContent>
      </Card>
    </StyledDetailsTable.Container>
  );
};

export default DetailsTableAccidents;
